import * as cookieHelper from "../../helpers/cookie"
import config from "react-global-configuration"
import { parkingState } from "../zustand/parkingState"
import { FlowEnum } from "../constants/flowEnums"

export const getAgeFromDate = (date) => {
  const today = new Date()
  const birthDate = new Date(date)
  let age = today.getFullYear() - birthDate.getFullYear()
  var month = today.getMonth() - birthDate.getMonth()
  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

export const trackPageView = (props, pageType, virtualPath) => {
  const userId = cookieHelper.getUserId(props)
  const { userAccountDetails } = props
  let data = {
    pageSkipPageview: "yes",
    virtualPath: getVirtualPath(virtualPath),
    event: "track-vp",
    userLoggedIn: userId !== null,
    userParkingArrivalDate: props.bookingResult ? props.bookingResult.booking.arrivalDate : props.arrivalDate,
    userParkingDepartureDate: props.bookingResult ? props.bookingResult.booking.departureDate : props.departureDate,
    pageType: pageType,
    pageLanguage: config.get("locale"),
    pageBusinessunit: "parking",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userAccountDetails) {
    const { ContactDetails } = userAccountDetails
    data.userId = userId
    data.userLanguage = navigator.language
    data.userAge = getAgeFromDate(ContactDetails.Birthdate)
    data.userGender = ContactDetails.Gender === 1 ? "male" : "female"
    data.userCountry = ContactDetails.Address.CountryCode
    data.userPostalCode = ContactDetails.Address.PostalCode
  }
  data = deleteNullProperty(data)
  window.dataLayer.push(data)
}
export const getProducts = (upsaleTrackingData) => {
  const { booking, product, carPark, activeBookingExtraProducts } = parkingState.getState().bookingResult
  let products = []
  let trackingProduct = {
    id: product.id, // Transaction ID. Required.
    name: `${product.name} - ${carPark.name}`, // Product name. Required.
    price: parseFloat(booking.items.parkings[0].amount) * 0.8, // Unit price.
    brand: "n/a",
    category: "parking",
    quantity: 1, // Quantity.
    dimension7: booking.duration,
  }
  if (upsaleTrackingData && upsaleTrackingData.upsaleProductId === product.id) {
    trackingProduct.dimension19 = upsaleTrackingData.productName
  }
  products.push(trackingProduct)

  activeBookingExtraProducts.map((extra) => {
    const { product, variants } = extra
    const { priceOffer, productOffer } = variants[0]
    products.push({
      id: product.id, // Transaction ID. Required.
      name: product.name === productOffer.name ? `Extra Services - ${product.name}` : `Extra Services - ${product.name} - ${productOffer.name}`, // Product name. Required.
      price: parseFloat(priceOffer.amount) * 0.8, // Unit price.
      brand: "n/a",
      category: "extra service",
      variant: product.offerName,
      quantity: 1, // Quantity.
    })
    return null
  })
  return products
}
export const trackOrderComplete = (props) => {
  const { booking } = parkingState.getState().bookingResult
  if (!booking) return
  const products = getProducts(props)

  const userId = cookieHelper.getUserId(props)
  const data = {
    event: "parking-purchase",
    eventCategory: "ecommerce",
    eventAction: "purchase",
    eventLabel: "parking",
    eventValue: booking.netPrice,
    eventNoninteraction: true,
    userParkingArrivalDate: booking.arrivalDate,
    userParkingDepartureDate: booking.departureDate,
    pageBusinessUnit: "parking",
    isNewDesign: parkingState.getState().useNewDesign ?? false,
    logged_in: cookieHelper.isLoggedIn(),
    ecommerce: {
      purchase: {
        actionField: {
          id: booking.reference,
          affiliation: "parking",
          revenue: booking.price,
          tax: booking.price - booking.netPrice,
          shipping: 0,
          coupon: booking.promotionCode,
        },
        products: products,
      },
    },
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
  trackPaymentOptions(props)
}

export const trackParkingFlowClick = (eventAction, eventLabel) => {
  const userId = cookieHelper.getUserId()
  let data = {
    pageBusinessUnit: "parking",
    userParkingArrivalDate: parkingState.getState().arrivalDate,
    userParkingDepartureDate: parkingState.getState().departureDate,
    eventCategory: "parking flow",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    event: "track-event",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}

export const trackParkingEngagementClick = (eventAction, eventLabel) => {
  const data = {
    event: "track-event",
    eventCategory: "engagement",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const getVirtualPath = (virtualPath, _locale) => {
  const locale = _locale ?? config.get("locale")
  switch (locale) {
    case "da":
      return virtualPath.replace("(|en/|sv/)", "")
    case "en":
      return virtualPath.replace("(|en/|sv/)", "en/")
    case "sv":
      return virtualPath.replace("(|en/|sv/)", "sv/")
    default:
      return virtualPath
  }
}

export const trackPermissionOptIn = (props, eventAction, eventLabel) => {
  const userId = cookieHelper.getUserId(props)
  let data = {
    userParkingArrivalDate: props.arrivalDate,
    userParkingDepartureDate: props.departureDate,
    eventCategory: "permission",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    event: "track-event",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}

const trackPaymentOptions = (props, paymentType = null) => {
  const { booking } = parkingState.getState().bookingResult
  if (!booking) return
  const { selectedPaymentType } = props
  const label = selectedPaymentType ? selectedPaymentType.cardType : paymentType
  const userId = cookieHelper.getUserId(props)
  const data = {
    event: "track-event",
    eventCategory: "parking flow",
    eventAction: "options - payment type",
    eventLabel: label,
    eventValue: booking.netPrice,
    eventNoninteraction: true,
    userParkingArrivalDate: booking.arrivalDate,
    userParkingDepartureDate: booking.departureDate,
    pageBusinessUnit: "parking",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}

export const trackCTALoginButtonClick = async (eventLabel) => {
  const data = {
    eventCategory: "cph profile",
    eventAction: "cta click - login",
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    event: "track-event",
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

const deleteNullProperty = (obj) => {
  for (let propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName]
    }
  }
  return obj
}

export const trackParkingProductUpgrade = (props, bookingData, eventLabel) => {
  const bookingResult =
    parkingState.getState().currentFlow === FlowEnum.STANDARDFLOW || FlowEnum.STANDARDRECEIPT
      ? parkingState.getState().bookingResult
      : parkingState.getState().manageBookingResult
  const booking = bookingResult?.booking
  if (!booking) return
  const userId = cookieHelper.getUserId(props)
  const data = {
    pageBusinessunit: "parking",
    userParkingArrivalDate: booking.arrivalDate,
    userParkingDepartureDate: booking.departureDate,
    eventCategory: "parking flow",
    eventAction: "product upgrade",
    eventLabel: `${eventLabel} - ${bookingData.productName} > ${bookingData.upsaleProductName}`,
    eventValue: bookingData.upsaleValue,
    eventNoninteraction: true,
    event: "track-event",
    userParkingIsAmendment: parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOW,
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}

export const trackBamboraShow = (bookingResult) => {
  const { booking } = bookingResult
  const userId = cookieHelper.getUserId()
  const data = {
    event: "track-event",
    eventCategory: "parking flow",
    eventAction: "payment",
    eventLabel: "bambora window opened",
    eventValue: 0,
    eventNoninteraction: true,
    userParkingArrivalDate: booking.arrivalDate,
    userParkingDepartureDate: booking.departureDate,
    pageBusinessunit: "parking",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}

export const trackParkingInteraction = (props, event) => {
  const { booking } = parkingState.getState().bookingResult
  if (!booking) return

  const products = getProducts(props)
  const userId = cookieHelper.getUserId(props)
  const data = {
    event: event,
    currency: "DKK",
    value: booking.netPrice,
    logged_in: cookieHelper.isLoggedIn(),
    items: products,
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}
